import { render, staticRenderFns } from "./Notifications.html?vue&type=template&id=ab2d2092&scoped=true&external"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"
import style0 from "./Notifications.scss?vue&type=style&index=0&id=ab2d2092&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2d2092",
  null
  
)

export default component.exports